import Marquee from "react-fast-marquee";
import { SectionHead } from "./Shared";

const BRANDS = ["Whirlpool", "Maytag", "Kenmore", "Samsung", "LG", "Frigidaire", "KitchenAid", "GE", "Insignia"];

export default function BrandsMarquee() {
  return (
    <section id="marcas" data-testid="brands-section" className="overflow-hidden bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHead
          num="01"
          testid="brands-title"
          title="Las marcas que conoces y en las que confías"
          sub="Trabajamos con fabricantes líderes de Estados Unidos y el mundo, importados directamente para tu hogar."
        />
      </div>
      <div data-testid="brands-marquee" className="select-none">
        <Marquee speed={25} gradient={false} pauseOnHover>
          {BRANDS.map((b) => (
            <span key={b} className="mx-8 flex items-center gap-8 md:mx-12 md:gap-12">
              <span className="whitespace-nowrap text-5xl font-extrabold tracking-tighter text-primary/15 transition-colors duration-500 hover:text-primary/60 md:text-7xl">
                {b}
              </span>
              <span className="h-2 w-2 rounded-full bg-whatsapp/60" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
